import { Component, OnInit, Inject, Input } from '@angular/core';

import { Router,ActivatedRoute } from '@angular/router';

import {AuthService} from "../../login/services/auth.service";
import {AssessmentService } from "../../shared/services/assessment.service";
import { Assessment } from "../../shared/models/assessment";
import { QuestionSet} from "../../shared/models/question-set";
import { AssessmentResult } from "../../shared/models/assessment-result";
import { ManagedClient } from "../../shared/models/managed-client";
import {AssessmentGraderService } from "../../shared/services/assessment-grader.service";

import { ReportService } from 'app/reports/services/report.service';
import { Assignment } from 'app/shared/models/Assignment';
import { AssignedAssessment } from 'app/shared/models/AssignedAssessment';
import { ClientService } from 'app/shared/services/client.service';
import { AlertService } from 'app/shared/services/alert.service';
@Component({
  selector: 'app-take-assessment',
  templateUrl: './take-assessment.component.html',
  styleUrls: ['./take-assessment.component.css']
})
export class TakeAssessmentComponent implements OnInit {

	private _assignment:AssignedAssessment;
	private _assessment:Assessment;
	private _$state:any;
	private _loading:boolean;
	private _saving:boolean;
	private _saveError:boolean;
	private _currentQuestionSet:QuestionSet;
	private _currentIndex = 0;
	private _maxQuestionSetsIndex = 0;
	private _client:ManagedClient;

  @Input() redirectUrl:string;

  constructor(
    private AssessmentService:AssessmentService, 
    private router:Router,
    private authService:AuthService,
    private route: ActivatedRoute,
	private assessmentGrader:AssessmentGraderService,
	private clientService:ClientService,
	private reportService:ReportService,
	private alertService:AlertService) { 
	}

  ngOnInit() {
    // this.loading = true;

		this.authService.getCurrentClient().then((client) => {
			this._client = client;

				// not sure I like this nested, but it does handle duplicate requests for the uid.
			this.route.params.subscribe((params) => {
				let uid = params['uid'];
				this.AssessmentService.uid = uid;
				this.AssessmentService.clientId = client.id;

				

				// TODO: stephen this is a dangerous assumption but we can use it for now
				// we need to restructure things to use the assignment, not the test uid, as a user 
				// could have more than one test assigned... although this is unlikely
				
				this.setupAssignment(client, uid)
				if (this.hasAssignment()) {
					this.navigateToAssignmentResultForClient(client, uid, this._assignment.ResultId, this._assignment);
				}
				else {
					this.loadAssessment(uid);
				}
			});
		}); 
  }

  private setupAssignment(client:ManagedClient, uid) {
	  this._assignment = client.findAssignmentItemForAssessmentUid(uid);
  }

  private hasAssignment() {
	return this._assignment && this._assignment.ResultId
  }

  private navigateToAssignmentResultForClient(client:ManagedClient, uid, resultId:string, assignmentItem:AssignedAssessment) {

	let assignment = this._client.findAssignmentForAssignmentItem(assignmentItem);
	this.reportService.getReportsForAssignment(assignment)
	.then(reports => {
		if (reports && reports.length) {
			let singleReport = reports[0];
			this.router.navigate(['assessments',client.id, 'reports', singleReport.id, assignment.Id]);
		}
		else {
			// we go to the default location if there is no reports.
			this.router.navigate(["assessments", client.id, "result", resultId]);
		}
	})
	.catch(error => {
		console.error(error);
	});
  }
  private loadAssessment(uid) {
	this.AssessmentService.getAssessment(uid).then((assessment) => {
		this.loading = false;
		this._assessment = assessment;
		
})
.catch((response) => {
		this.loading = false;			
		console.error(response); 
});
  }

	
  public get assessment() : Assessment {
    return this._assessment;
  }

	
	public get loading() : boolean {
		return this._loading;
	}
	
	
	public set loading(v : boolean) {
		this._loading = v;
	}
	
	public get saving() : boolean {
		return this._saving;
	}
	
	
	public set saving(v : boolean) {
		this._saving = v;
	}
	
	public get saveError() : boolean {
		return this._saveError;
	}
	
	
	public set saveError(v : boolean) {
		this._saveError = v;
	}

	private shouldRedirect() : boolean {
		return this.redirectUrl != null;
	}

	private redirectToNewUrl() {
		// TODO: make this the hydrated url
		window.location.href = this.redirectUrl;
	}

	submit(assessment:Assessment) {
		this.saveError = false;
		this.saving = false;
		
		var result = this.assessmentGrader.grade(assessment);
		result.assignmentItemId = (this._assignment ? this._assignment.Id : null);
		this.saving = true;
		let savingMsg = this.alertService.info("Computing your test results and saving your scores....", 600000)
		this.AssessmentService.saveAssessmentResult(result)
			.then((result:AssessmentResult) => {
				this.alertService.success("Saved results for " + assessment.name);
				this.alertService.clearAlert(savingMsg);
				// reload the client, grab the assignment and let's continue
				// TODO: stephen I don't like this... we need to return the assignment but we don't have it on the server...
				// how can we move forward with this?
				return this.clientService.getClient(this._client.id)
				.then(client => {
					this.setupAssignment(client, assessment.uid);
					this.navigateToAssignmentResultForClient(this._client, this.assessment.uid, result.id, this._assignment);
				});
			}, function() {	
				console.error("Failed to save json result");
				this.saving = false;
				this.saveError = true;
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/assessments/take-assessment/take-assessment.component.ts